<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
const primary = ref('rgb(var(--v-theme-primary))');
const secondary = ref('rgb(var(--v-theme-secondary))');
import LogoMini from '/public/images/logos/snapei-b2b-solo.svg'
</script>
<template>
    <div>
        <NuxtLink to="/" class="pa-1">
            <VImg :src="LogoMini" height="60" width="60" >
            </VImg>
        </NuxtLink>
    </div>
</template>